export const ACTIVE_FILTERS_CONTAINER_ID = "activeFilters";
